import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <a href="/" className="flex items-center gap-2 text-xl font-bold text-foreground-900 tracking-tight mb-3">
              <span className="text-primary-500">ACB</span>
              <span className="text-foreground-700 font-medium">Spreadsheet</span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed">
              {t('footer_tagline')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_links')}
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('nav_home')}
                </a>
              </li>
              <li>
                <a href="/article/allchinabuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('article_title')}
                </a>
              </li>
              <li>
                <a href="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('nav_about')}
                </a>
              </li>
              <li>
                <a href="/contact" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('nav_contact')}
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-foreground-900 uppercase tracking-wider mb-4">
              {t('footer_legal')}
            </h3>
            <ul className="space-y-2">
              <li>
                <a href="/privacy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer_privacy')}
                </a>
              </li>
              <li>
                <a href="/terms" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer_terms')}
                </a>
              </li>
              <li>
                <a href="/disclaimer" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer_disclaimer')}
                </a>
              </li>
              <li>
                <a href="/editorial-policy" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  {t('footer_editorial')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            © {currentYear} {t('footer_copyright').replace(/^©\s*\d{4}\s*/, '')}
          </p>
          <p className="text-xs text-foreground-400">
            {t('footer_nofollow_notice')}
          </p>
        </div>
      </div>
    </footer>
  );
}